import type { TransactionPayload } from '@ankor-io/common/types/transaction/transaction'

/**
 * Builds a short display name from `firstName` / `lastName` (e.g. `transactedBy` or `settledBy` on a transaction).
 * Returns `"firstName lastName"` when both are non-empty (after trim), otherwise the single non-empty part, otherwise `'-'`.
 * Does not use email. Empty strings count as missing (e.g. gratuity rows with no named spender).
 *
 * @param user - Who performed or settled the transaction, or undefined
 */
export const formatUsername = (user: TransactionPayload['transactedBy'] | TransactionPayload['settledBy']): string => {
  if (!user) {
    return '-'
  }

  const { firstName, lastName } = user

  // Helper to check if a string is non-empty
  const hasValue = (value: string | undefined): boolean => {
    return Boolean(value && value.trim().length > 0)
  }

  // If both firstName and lastName are available, combine them
  if (hasValue(firstName) && hasValue(lastName)) {
    return `${firstName} ${lastName}`
  }

  // If only one name is available, use it
  if (hasValue(firstName)) {
    return firstName!
  }

  if (hasValue(lastName)) {
    return lastName!
  }

  // Final fallback
  return '-'
}
